import { Routes, Route } from 'react-router-dom';
import { Login, Recovery, NewPassword, LoginDecision } from './auth/presentation';
import CheckAuth from './auth/oidc/CheckAuth';
import RedirectCallBack from './auth/oidc/RedirectCallBack';
import { HomePage } from '@/homepage/presentation';

const ROUTES = {
  auth: {
    homepage: process.env.PUBLIC_URL,
    login: `${process.env.PUBLIC_URL}/login`,
    recovery: `${process.env.PUBLIC_URL}/recovery-password`,
    newPassword: `${process.env.PUBLIC_URL}/new-password`,
    postNewPassword: `${process.env.PUBLIC_URL}/post-new-password`,
    sso_btg: `${process.env.PUBLIC_URL}/sso-btg`,
    redirect_sso: `${process.env.PUBLIC_URL}/redirect_sso`,
  },
  proposals: '/',
};

const Router = (props: any) => (
  <Routes>
    <Route path={ROUTES.auth.homepage} element={<HomePage />} />
    <Route path={ROUTES.auth.login} element={<Login />} />
    <Route path={ROUTES.auth.recovery} element={<Recovery />} />
    <Route path={ROUTES.auth.newPassword} element={<NewPassword />} />
    <Route path={ROUTES.auth.postNewPassword} element={<LoginDecision />} />
    <Route path={ROUTES.auth.sso_btg} element={<CheckAuth {...props} />} />
    <Route path={ROUTES.auth.redirect_sso} element={<RedirectCallBack {...props} />} />
    <Route path="*" element={<h1>Not Found</h1>} />
  </Routes>
);

export { Router, ROUTES };
